// @ts-nocheck

import { match as MatchStateUtils } from '..';
import type { ScoreboardProps } from '../../states/scoreboards';

export default ({
  sportId,
  matchId,
  period,
  periodName,
  competitor1Name,
  competitor2Name,
  competitor1Flag,
  competitor2Flag,
  setScores,
}: unknown): ScoreboardProps => {
  let scores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
        nbRedCards: 0,
        scorers: [],
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
        nbRedCards: 0,
        scorers: [],
      },
    ],
    scores: {
      main: {
        score: scores
          ? [MatchStateUtils.computeScore(scores, 0, 3), MatchStateUtils.computeScore(scores, 1, 3)]
          : ['', ''],
        isActive: false,
      },
      secondaries: [],
    },
    isCompact: true,
  };
};
